import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './programs.css';
import { FaGraduationCap, FaCapsules, FaLaptopCode, FaAssistiveListeningSystems, FaBookOpen } from 'react-icons/fa';

const Programs = () => {
  const programs = [
    {
      id: 1,
      title: "Information Technology",
      description: "Gain a strong foundation in computer systems, software applications, and digital technologies. This course is ideal for beginners looking to enter the tech industry or enhance their digital literacy.",
      icon: <FaLaptopCode size={40} />,
  duration: "06 Months",
  degree: "Certificate Level"
},

{
  id: 2,
  title: "Pharmacology",
  description: "Explore the fundamentals of drug action, dosage, and therapeutic uses. Perfect for those interested in pharmacy, healthcare, or clinical support roles.",
  icon: <FaCapsules size={40} />,
  duration: "1 Year",
  degree: "Certificate Level"
},

{
  id: 3,
  title: "Audiology",
  description: "Delve into the science of hearing and balance. This diploma covers hearing assessment, hearing aid technologies, and patient care for those pursuing a healthcare profession.",
  icon: <FaAssistiveListeningSystems size={40} />,
  duration: "2 Years",
  degree: "Diploma"
},

{
  id: 4,
  title: "English",
  description: "Improve your communication, grammar, and comprehension skills. This course is designed for academic, professional, and everyday use of the English language.",
  icon: <FaBookOpen size={40} />,
  duration: "06 Months",
  degree: "Certificate Level"
}


    
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div 
      className="programs-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="programs-header">
        <h1><FaGraduationCap /> Academic Programs</h1>
        <p>World-class technical education shaping the innovators of tomorrow</p>
        <div className="header-decoration"></div>
      </div>

      <motion.div className="programs-grid" variants={containerVariants}>
        {programs.map((program) => (
          <motion.div 
            key={program.id} 
            className="program-card"
            variants={itemVariants}
            whileHover={{ y: -5, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}
          >
            <div className="program-icon">{program.icon}</div>
            <h3>{program.title}</h3>
            <p>{program.description}</p>
            <div className="program-meta">
              <span>{program.duration}</span>
              <span>{program.degree}</span>
            </div>
            <button className="learn-more-btn">Explore Program</button>
          </motion.div>
        ))}
      </motion.div>

      <div className="programs-cta">
        <h2>Can't find your desired program?</h2>
        <p>Our academic advisors can help you find the perfect fit for your career goals</p>
        <Link to="/contactus">
        <button className="cta-button">Contact Academic Advisor</button>
        </Link>
      </div>
    </motion.div>
  );
};

export default Programs;